import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { CommonButtonPopup } from "../../ReportsV2/styles";
import PropTypes from "prop-types";
import { AdminDownloadIcon, SpotPointsGiftIcon } from "../../../utils/icons";
import { commaSeperator, getInitials } from "../../../utils/methods";
import { ImageUrl } from "../../../utils/constants";
import { UserInitialsMain } from "../../SocialFeedsV2/styles";
import SpotPointsReportModal from "./SpotPointsReportModal";
import { connect } from "react-redux";
import { getCompanyDepartment, getCompanyLocation } from "../../../redux/actions";
import HoverButton from "../../common/HoverButton";

const CardsWrapper = styled.div`
display:flex;
gap:20px;
`;

const MainCard = styled.div`
width:614px;
height:480px;
padding:16px;

border-radius:12px;
border:0.75px solid #DCDCDC;
background:#FEFEFE;

display:flex;
flex-direction:column;
`;

const CardTitle = styled.div`
color:#184A61;
font-family:Lato;
font-size:18px;
font-weight:700;
line-height:24px;
`;

const Divider = styled.hr`
margin-top:20px;
margin-bottom:12px;
border:0.75px solid #DCDCDC;
`;

const InnerCard = styled.div`

border-radius:12px;
border:0.75px solid #DCDCDC;
background:#FEFEFE;
padding:16px 16px 7px 16px;

display:flex;
flex-direction:column;
flex:1;   /* 🔥 take full height */

${'' /* align-items:center; */}
`;

const InnerContent = styled.div`
display:flex;
flex-direction:column;
flex:1; /* takes remaining space */
`;

const InnerTitle = styled.div`
color:#184A61;
font-family:Lato;
font-size:18px;
font-weight:700;
line-height:24px;
`;

const InnerText = styled.div`
color:#184A61;
font-family:Lato;
font-size:16px;
font-weight:400;
line-height:20px;
margin-top:8px;
`;

const PointsCenter = styled.div`
display:flex;
flex-direction:column;
${'' /* align-items:center; */}
margin-top:40px;
`;

const PointsNumber = styled.div`
color:#184A61;
font-family:Lato;
font-size:64px;
font-weight:700;
line-height:78px;
`;

const PointsSubText = styled.div`
color:#7C7C7C;
font-family:Lato;
font-size:16px;
font-weight:400;
line-height:20px;
`;

const BottomRow = styled.div`
display:flex;
align-items:center;
justify-content:space-between;
width:100%;
${'' /* margin-top:30px; */}
margin-top:auto; /* 🔥 pushes to bottom */
`;

const IconContainer = styled.div`
  margin-right:40px;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LeadersHeader = styled.div`
border-radius:6px;
border:1px solid #EFEFEF;
background:#F8F8F8;

display:flex;
justify-content:space-between;

padding:10px 16px;
font-family:Lato;
font-size:14px;
font-weight:400;
color:#184A61;
`;

const LeaderCard = styled.div`
border-radius:8px;
border:0.75px solid #DCDCDC;
background:#FEFEFE;

display:flex;
justify-content:space-between;
align-items:center;

padding:8px 16px;
margin-top:4px;
`;

const LeaderInfo = styled.div`
display:flex;
align-items:center;
gap:12px;
`;

const LeaderImage = styled.div`
width:48px;
height:48px;
border-radius:50%;
  .img{
  object-fit:cover;
  width:48px;
  height:48px;
  border-radius:50%;
}
`;

const LeaderDetails = styled.div`
display:flex;
flex-direction:column;
`;

const LeaderName = styled.div`
font-family:Lato;
font-size:16px;
font-weight:400;
color:#184A61;
`;

const LeaderDate = styled.div`
font-family:Lato;
font-size:14px;
color:#7C7C7C;
`;

const LeaderPoints = styled.div`
font-family:Lato;
font-size:18px;
font-weight:700;
color:#184A61;
`;

const NoData = styled.div`
height:100%;
display:flex;
align-items:center;
justify-content:center;

.text{
    width:346px;
}

color: #989898;
text-align: center;
font-family: Lato;
font-size: 24px;
font-style: normal;
font-weight: 700;
line-height: 30px; 
`;

const TitleRow = styled.div`
display:flex;
justify-content:space-between;
align-items:center;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .downloadIcon{
    cursor:pointer;
  }
`;

const ViewAll = styled.div`
display:flex;
align-items:center;
gap:6px;
cursor:pointer;

color:#DA6C74;
text-align:right;

font-family:Lato;
font-size:16px;
font-weight:400;
line-height:20px;

text-decoration:underline;
`;

const SpotPointsDashboard = ({ history, leaders = [], totalPoints = 0 , locationDetails , departmentDetails, companyInfo , selectedYear, getCompanyLocation , getCompanyDepartment }) => {
  const [spotPoints , setSpotPointsModal] = useState(false);

  const containsDefaultPng = (path) => path === "profile-Image/default.png";

  useEffect(() => {
    getCompanyLocation(companyInfo?.id);
    getCompanyDepartment(companyInfo?.id);
  }, []);



  const handleAwardPoints = () => {
    history.push("/company/rewards/create-spot-points");
  };

  return (
    <CardsWrapper>
      {/* CARD 1 */}
      <MainCard>
        <CardTitle>Award Spot Points</CardTitle>
        <Divider />
        <InnerCard>
          <InnerContent>
            <InnerTitle>Recognize with Spot Points</InnerTitle>
            <InnerText>
              Award points to employees for achievements and wins
            </InnerText>
            <PointsCenter>
              <PointsNumber>{commaSeperator(totalPoints)}</PointsNumber>
              <PointsSubText>
                Total Spot Points Awarded
              </PointsSubText>
            </PointsCenter>
          </InnerContent>
          <BottomRow>
            <CommonButtonPopup
              height="40px"
              width="300px"
              margin="16px 0px 0px 0px"
              background={"#DA6C74"}
              onClick={handleAwardPoints}
            >
              {SpotPointsGiftIcon()}
              Award Spot Points
            </CommonButtonPopup>
            <IconContainer>
              {/* <SpotPointsIcon/> */} 
              {/* {SpotPointsIcon()} */}
              <img  src="/public/images/SpotsPoints.svg" alt="icon"/>
            </IconContainer>
          </BottomRow>
        </InnerCard>
      </MainCard>

      {/* CARD 2 */}
      <MainCard>
        <TitleRow>
          <CardTitle>Spot Points Leaders</CardTitle>
          {leaders?.length > 0 && (
            <RightSection>
              {/* <div className="downloadIcon"  onClick={()=> setSpotPointsModal(true)}>{AdminDownloadIcon(24,24)}</div> */}
              <HoverButton
                title="Download"
                svgPath={AdminDownloadIcon(20,24)}
                onClick={()=> setSpotPointsModal(true)}
                width={"20px"}
                height={"24px"}
                fillOpacity={1}
                activeColor={"#DA6C74"}
                inActiveColor={"#DA6C74"}
                backgroundColor={"#FCF2F3"}
                backgroundColorActive={"#DA6C74"}
              />
              <ViewAll onClick={() => history.push("/company/rewards/spot-points")}>
              View All &gt;&gt;
              </ViewAll>
            </RightSection>
          )}

        </TitleRow>
        <Divider />
        <LeadersHeader>
          <span>Name</span>
          <span>Points Received</span>
        </LeadersHeader>
        {leaders?.length > 0 ? (
          leaders.map((item, index) => (
            <LeaderCard key={index}>
              <LeaderInfo>
                {/* <LeaderImage src={ImageUrl + "/" + item.profile_image} /> */}
                <LeaderImage>
                  {!containsDefaultPng(item?.profile_image) ? (
                    <img className="img" src={ImageUrl + "/" + item.profile_image} />
                  ) : (
                    <UserInitialsMain color={"#184A61"} isBg border size="16px">
                      {getInitials(item?.name)}
                    </UserInitialsMain>
                  )}
                </LeaderImage>
                <LeaderDetails>
                  <LeaderName>{item.name}</LeaderName>
                  <LeaderDate>{item.awarded_at}</LeaderDate>
                </LeaderDetails>
              </LeaderInfo>
              <LeaderPoints>{commaSeperator(item.points_received)}</LeaderPoints>
            </LeaderCard>
          ))

        ) : (
          <NoData>
            <span className="text">Award spot points to your employees to view data.</span>
          </NoData>
        )}
      </MainCard>

      {spotPoints && <SpotPointsReportModal selectedYear={selectedYear} companyInfo={companyInfo} departmentDetails={departmentDetails}  locationDetails={locationDetails} show={spotPoints} title={'Export Rewards Report'} onCancel={()=>setSpotPointsModal(false)}/>}
      
    </CardsWrapper>
  );
};

SpotPointsDashboard.propTypes = {
  history: PropTypes.object,
  totalPoints:PropTypes.number,
  leaders:PropTypes.array,
  locationDetails:PropTypes.array,
  departmentDetails:PropTypes.array,
  companyInfo:PropTypes.object,
  selectedYear: PropTypes.string,
  getCompanyDepartment:PropTypes.func,
  getCompanyLocation:PropTypes.func
};


const mapStateToProps = (state) => ({
  locationDetails: state.register.locationDetails,
  departmentDetails: state.register.departmentDetails,
  companyInfo: state.companyDashboard.companyInfo,

});

const mapDispatchToProps = (dispatch) => ({
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
  getCompanyDepartment: (id) => dispatch(getCompanyDepartment(id))
});


export default (connect(mapStateToProps, mapDispatchToProps)(SpotPointsDashboard));

// export default SpotPointsDashboard;